module.exports = __webpack_public_path__ + "img/defaultImage-3935b727f67ab3432b7bb60fba4daff3.svg";